<app-search-field [(ngModel)]="query" />

<app-checkbox
  class="checkbox-filter"
  [checked]="allChecked"
  [indeterminate]="isIndeterminate"
  (checkedChange)="toggle($event)">
  Select all ({{ count() }})
</app-checkbox>

<div class="checkbox-list">
  @for (checkbox of viewDictionary(); track checkbox.id) {
    <app-checkbox
      class="checkbox-filter"
      [checked]="selectedSet.has(checkbox.id)"
      (checkedChange)="toggleOne(checkbox.id)">
      {{ checkbox.name }}
    </app-checkbox>
  }
</div>
